define('lib/Podio.UI.FileFinder',['require','translate','underscore','jquery','backbone','collections/Podio.Collections.LinkedFiles','collections/Podio.Collections.LinkedAccounts','views/lib/Podio.Views.SideTabsBadgeCount','views/filefinder/Podio.Views.FileFinder','views/filefinder/Podio.Views.FileFinderAccountsList','views/filefinder/Podio.Views.FileFinderUpload','views/filefinder/Podio.Views.FileFinderFileList','views/filefinder/Podio.Views.FileFinderPermissionWarning','views/filefinder/Podio.Views.FileFinderPermissionSettings','collections/Podio.Collections.AccountProviders','views/lib/Podio.Views.ProvidersMatrix','lib/backbone/Backbone.PodioModel','models/Podio.Models.User','lib/Podio.Config','lib/Podio.Transport','lib/Podio.Routes','lib/Podio.SingleSignOn','lib/Podio.UI.SettingsBalloon','lib/Podio.UI.FlashMessage','signals','lib/Podio.Utils','views/lib/Podio.Views.AccountsSettingsDropdown'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var Backbone = require('backbone');
  var collectionLinkedFiles = require('collections/Podio.Collections.LinkedFiles');
  var collectionLinkedAccounts = require('collections/Podio.Collections.LinkedAccounts');

  var viewSideTabsBadgeCount = require('views/lib/Podio.Views.SideTabsBadgeCount');
  var ViewFileFinder = require('views/filefinder/Podio.Views.FileFinder');
  var ViewFileFinderAccountsList = require('views/filefinder/Podio.Views.FileFinderAccountsList');
  var ViewFileFinderUpload = require('views/filefinder/Podio.Views.FileFinderUpload');

  var ViewFileFinderFileList = require('views/filefinder/Podio.Views.FileFinderFileList');
  var ViewFileFinderPermissionWarning = require('views/filefinder/Podio.Views.FileFinderPermissionWarning');
  var ViewFileFinderPermissionSettings = require('views/filefinder/Podio.Views.FileFinderPermissionSettings');

  var AccountProvidersCollection = require('collections/Podio.Collections.AccountProviders');
  var ProvidersMatrixView = require('views/lib/Podio.Views.ProvidersMatrix');

  var ModelPodioBase = require('lib/backbone/Backbone.PodioModel');
  var UserModel = require('models/Podio.Models.User');
  var podioConfig = require('lib/Podio.Config');

  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');
  var singleSignOn = require('lib/Podio.SingleSignOn');
  var settingsBalloon = require('lib/Podio.UI.SettingsBalloon');
  var flashMessage = require('lib/Podio.UI.FlashMessage');
  var signalsLib = require('signals');
  var utils = require('lib/Podio.Utils');

  var defaultSettings = {
    allowedMimeTypes    : [],
    multipleFiles       : true,
    onlyAllowImages     : false,
    onlyAllowVideos     : false,
    onlyPodioFiles      : false,
  };

  var PodioFileFinder = function(settings) {

    settings = $.extend(true, {}, defaultSettings, settings );

    // Mime type handling
    if (settings.onlyAllowImages) {
      settings.allowedMimeTypes.push('image/gif');
      settings.allowedMimeTypes.push('image/jpeg');
      settings.allowedMimeTypes.push('image/pjpeg');
      settings.allowedMimeTypes.push('image/png');
    }

    if (settings.onlyAllowVideos) {
      settings.allowedMimeTypes.push('video/mpeg4');
      settings.allowedMimeTypes.push('video/mp4');
      settings.allowedMimeTypes.push('video/ogg');
      settings.allowedMimeTypes.push('video/quicktime');
      settings.allowedMimeTypes.push('video/webm');
      settings.allowedMimeTypes.push('video/x-matroska');
      settings.allowedMimeTypes.push('video/x-ms-wmv');
      settings.allowedMimeTypes.push('video/x-flv');
    }

    settings.allowedMimeTypes = _.uniq( settings.allowedMimeTypes );

    var stateModel = new ModelPodioBase();

    var signals = {
      onDone  : new signalsLib.Signal(),
      onClose : new signalsLib.Signal(),
      onShow  : new signalsLib.Signal()
    };


    var linkedFiles = {}, linkedAccounts = new collectionLinkedAccounts();

    var tabViews = {}, badgeViews = {};
    var eventBridge = _.extend({}, Backbone.Events);
    var finderView, accountsListView, settingsDropdownView, permissionWarningView, permissionSettingsView;

    var userModel = new UserModel();

    var helpers = {

      initFinderView : function () {
        if ( finderView ) {
          return;
        }

        finderView = new ViewFileFinder({
          model       : {},
          el          : $('<div />', { 'class' : 'file-finder-wrapper'}),
          eventBridge : eventBridge,
          onlyPodioFiles: settings.onlyPodioFiles,
        });

        finderView.render();

        helpers.initAccountsList();

      },

      getLinkedAccountId : function(providerName) {
        return stateModel.get('{0}_linked_account_id'.format(providerName));
      },

      setLinkedAccountId : function(providerName, linked_account_id, isSlient) {

        var accountProp = '{0}_linked_account_id'.format(providerName);
        var data = {};
        data[accountProp] = linked_account_id;

        if(isSlient) {
          stateModel.set(data, { silent: true });
        } else {
          stateModel.set(data);
        }

      },

      setSelectedFilesCount : function(providerName, filesCount) {

        var badgeView = badgeViews[providerName];
        badgeView.count = filesCount;
        badgeView.render();

      },

      initAccountsList : function() {
        if(accountsListView || settings.onlyPodioFiles) {
          return;
        }

        // Get accounts
        if(!settings.onlyPodioFiles) {
          linkedAccounts.getConnectedByCapability('files').then(function() {
            if (podioConfig.user.from_sharefile) {
              var account = linkedAccounts.find(function (item) {
                return item.get('provider') === 'sharefile_limited';
              });

              onChangeTab(account);
            }
          });
        }

        // Render view
        accountsListView = new ViewFileFinderAccountsList({
          model: linkedAccounts,
          el: finderView.elm.find('.navigation'),
          elmList: finderView.elm.find('ul.providers'),
          eventBridge: eventBridge
        });

        accountsListView.render();
      },

      initFileListTab : function(account, options) {
        var providerName = account.get('provider');

        var files    = linkedFiles[providerName]    = new collectionLinkedFiles([], { 'linked_account_type' : providerName });
        var accountProp = '{0}_linked_account_id'.format(providerName);

        stateModel.bind('change:{0}'.format(accountProp), function() {
          // Refresh files for new selected account
          files.linked_account_id = stateModel.get(accountProp);
          files.mime_types = settings.allowedMimeTypes;
          files.regenerate_url();
          files.clearCache();
          files.fetch({ reset: true });
        });

        files.bind('reset', function() {
          // Switch to correct tab, once files has been loaded
          onChangeTab(account);
        });


        if(!stateModel.get(accountProp)) {
          var firstAccount = linkedAccounts.getByProvider( providerName )[0];
          helpers.setLinkedAccountId(providerName, firstAccount.get('linked_account_id'));
        }

        if (options.eventBridge) {
          delete options.eventBridge;
        }
        var viewOptions = $.extend(true, {}, options, {
          elmParent       : $('.file-finder-content .inner'),
          accounts        : linkedAccounts,
          files           : linkedFiles[providerName],
          providerName    : providerName,
          account         : account,
          selectionLimit  : settings.multipleFiles ? null : 1
        });
        viewOptions['eventBridge'] = eventBridge;

        tabViews[providerName] = new ViewFileFinderFileList(viewOptions);
        tabViews[providerName].render();
      },

      initSettingsView : function(options) {

        if(settingsDropdownView) {
          settingsDropdownView.dispose();
        }

        // Create wrapper element
        var elmSettingsOptionsWrapper = $('.file-finder-settings-option');
        if(!elmSettingsOptionsWrapper.length) {
          elmSettingsOptionsWrapper = $('<div />', { 'class': 'balloon fixed below settings-balloon within-modal file-finder-settings-options'});
          elmSettingsOptionsWrapper.appendTo(finderView.elm);
          elmSettingsOptionsWrapper.css('width', 'auto');
        }

        // Render
        var accSettingsView = require('views/lib/Podio.Views.AccountsSettingsDropdown');
        settingsDropdownView = new accSettingsView({
          el                     : elmSettingsOptionsWrapper,
          eventBus               : eventBridge,
          account                : options.account,
          accounts               : linkedAccounts.getByProvider(options.account.get('provider')),
          state                  : stateModel,
          capability             : 'files',
          showPermissionSettings : true,
          preservePermissions    : helpers.getPreservePermissions(options.account.get('provider'))
        });

        settingsDropdownView.render();
      },

      initUploadTab : function() {

        tabViews['upload'] = new ViewFileFinderUpload({
          el : $('.file-finder-content .inner'),
          eventBridge : eventBridge,
          providerName  : 'upload',
          onlyAllowImages : settings.onlyAllowImages,
          onlyAllowVideos : settings.onlyAllowVideos,
          allowedMimeTypes : settings.allowedMimeTypes,
          multipleFiles : settings.multipleFiles
        });

        tabViews['upload'].render();
      },

      initTabView : function (account) {
        var type = account.get('provider');

        if ( tabViews[type] ) {
          // Already initialized, return
          return;
        }

        if( type === 'upload' ) {

          helpers.initUploadTab();

        } else {

          var providerName = type;
          helpers.initFileListTab(account, {
            eventBridge   : eventBridge,
            hasOptions    : true
          });
        }

        // Render
        badgeViews[type] = new viewSideTabsBadgeCount({
          el            : $('.file-finder-content ul.providers li[data-tab-name={0}] .img-ext'.format(type)),
          eventBridge   : eventBridge,
          providerName  : type,
          account       : account,
          color         : 'dark'
        });

        badgeViews[type].render();
      },

      hideOtherTabs : function (tabName) {
        _.each(tabViews, function (tab, key) {
          if ( key != tabName ) {
            tab.hide();
          } else {
            tab.show();
          }
        });
      },

      toggleOptionsButton : function(tabName) {
        if(tabViews[tabName].hasOptions) {
          finderView.showOptionsButton();
        } else {
          finderView.hideOptionsButton();
        }
      },

      getPreservePermissions : function(provider) {
        return userModel.getProperty('filefinder_preserve_external_file_permissions_'+provider);
      },

      setPreservePermissions : function(provider, value) {
        var property = 'filefinder_preserve_external_file_permissions_'+provider;

        if(value === null) {
          userModel.removeProperty(property);
        } else {
          userModel.setProperty(property, value);
        }

        settingsDropdownView.preservePermissions = value;
        settingsDropdownView.render();
      }
    };

    function _transportFiles(filesUploadedDfd, url, requestData) {
      var req = transport.postJSON(url, { requestData : requestData });

      req.done(function(responseData) {
        var files = (responseData.data && responseData.data.files) ? responseData.data.files : [];
        filesUploadedDfd.resolve(files);
      });

      req.fail(function() {
        filesUploadedDfd.reject();
      });
    }

    function _resolveFiles(promise) {
      var filesUploadedDfd = new $.Deferred();

      promise.then(function(data) {
        var requestData = {
          'linked_account_id' : helpers.getLinkedAccountId(data.provider)
        };

        if(!data.ids.length) {
          // No ids, return empty;
          filesUploadedDfd.resolve([]);
          return;
        }

        var url;

        // Resolve files from server
        if(data.type === 'file') {
          requestData['file_ids'] = data.ids;
          url = routes.list_files_path();

          _transportFiles(filesUploadedDfd, url, requestData);
          return;
        }

        if(data.type === 'external') {
          requestData['external_file_ids'] = data.ids;
          url = routes.create_from_external_file_id_path();

          var permissionOptions = data.account.permissionOptions();

          //We cannot do anything but preserve
          if (!permissionOptions.grant) {
            requestData['preserve_permissions'] = true;
            _transportFiles(filesUploadedDfd, url, requestData);
            return;
          }

          //There is a setting remembered
          if(helpers.getPreservePermissions(data.provider) !== null) {
            requestData['preserve_permissions'] = helpers.getPreservePermissions(data["provider"]);
            _transportFiles(filesUploadedDfd, url, requestData);
            return;
          }

          //Ask the user with detail on the possibility to preserve
          permissionWarningView = new ViewFileFinderPermissionWarning({
            eventBus: eventBridge,
            elmContainer: $('body'),
            canPreservePermissions: permissionOptions.preserve
          });

          permissionWarningView.render();

          permissionWarningView.dfd.done(function(rememberSetting, preservePermissions) {
            if(rememberSetting) {
              helpers.setPreservePermissions(data.provider, preservePermissions);
            }

            requestData['preserve_permissions'] = preservePermissions;
            _transportFiles(filesUploadedDfd, url, requestData);
          });

          permissionWarningView.dfd.fail(function() {
            filesUploadedDfd.resolve([]);
          });
        }
      });

      return filesUploadedDfd;
    }

    function onFinished() {
      _.each(tabViews, function (tab, key) {
        tab.hide();
      });

      finderView.minimize();
      finderView.clearErrors();

      finderView.hideOptionsButton();
      finderView.disableDoneButton();

      finderView.showUploadingLoader();

      var resolvedFilesFunc = _.compact(_.map(tabViews, function(tab) {
        if (_.isFunction(tab.getFiles)) {
          return _resolveFiles(tab.getFiles());
        } else {
          return null;
        }
      }));

      $.when.apply(this, resolvedFilesFunc).done(function() {
        var files = _.flatten(_.toArray(arguments));
        signals.onDone.dispatch(files);
        dispose();
      });

      $.when.apply(this, resolvedFilesFunc).fail(function() {
        finderView.renderError(t('Could not upload files. Please try again. #filefinder'));
        finderView.hideUploadingLoader();
        finderView.enableDoneButton();
      });
    }

    function onSettingsFinished(providerName, preservePermissions) {
      helpers.setPreservePermissions(providerName, preservePermissions);
    }

    function onConnectService(providerName) {

      singleSignOn.signals.onOAuthComplete.add(onOAuthComplete);
      singleSignOn.connect( providerName );
    }

    function onOAuthComplete(data) {
      // Refresh accounts
      linkedAccounts.getConnectedByCapability('files', {
        success : function() {
          onChangeAccount(data.provider, data.linked_account_id);
        }
      });
    }

    function onChangeTab(account) {
      var providerName = account.get('provider');

      helpers.initFinderView();

      if (accountsListView) {
        accountsListView.selectTab( providerName );
      }

      helpers.initTabView( account );

      helpers.hideOtherTabs( providerName );
      helpers.toggleOptionsButton( providerName );

      helpers.initSettingsView({
        account: account
      });

      // Signal to the world
      signals.onShow.dispatch();
    }


    function onChangeAccount(providerName, linkedAccountId) {
      // We are switching accounts. Make sure to reset folder if
      // since the current folder may not exist on the new account
      var existingFiles = linkedFiles[providerName];
      if (existingFiles) {
        existingFiles.external_folder_id = 'all';
      }

      var account = linkedAccounts.get(linkedAccountId);

      // Reset Selection state
      var providerTabView = tabViews[providerName];
      if( providerTabView ) {
        providerTabView.abortSearch();
        providerTabView.hideBlankslate();
        providerTabView.resetSelectionState();
        providerTabView.clearSearchField();
        providerTabView.account = account;
      }

      // Switch to tab
      eventBridge.trigger("changeTab", account);

      // Clear state
      helpers.setSelectedFilesCount(providerName, 0);

      // Force a refresh, even if the same account is chosen
      if(linkedAccountId === helpers.getLinkedAccountId(providerName)) {
        helpers.setLinkedAccountId(providerName, 0, true);
      }

      // Update linked account id
      helpers.setLinkedAccountId(providerName, linkedAccountId);
    }

    function onChangePermissionSettings(account) {
      permissionSettingsView = new ViewFileFinderPermissionSettings({
        eventBus: eventBridge,
        elmContainer: $('body'),
        providerName: account.get('provider'),
        canPreservePermissions: account.permissionOptions().preserve
      });

      permissionSettingsView.render();
    }

    function onFileListChanged(providerName) {

      $.when( tabViews[providerName].getFiles() ).then(function(data) {
        var filesCount = data.ids.length;

        if (filesCount > 0) {
          eventBridge.trigger('fileFinder:button:enable');
        } else {
          eventBridge.trigger('fileFinder:button:disable');
        }

        helpers.setSelectedFilesCount(providerName, filesCount);
      });

    }

    function onFileListLimitReached(providerName, fileId) {

      _.each(tabViews, function (tab) {
        if( _.isFunction(tab.clearSelectionExceptFileId) ) {
          if (providerName == tab.providerName) {
            tab.clearSelectionExceptFileId(fileId);
          }
          else {
            tab.clearSelection();
          }

          onFileListChanged(tab.providerName);
        }
      });
    }

    function onGetFolder(providerName, linkedAccountId, folderId) {

      function getParentFolderId(folderId) {
        var parentFolderId = linkedFiles[providerName].parentMap[folderId];

        if(!parentFolderId) {
          linkedFiles[providerName].parentMap[folderId] = linkedFiles[providerName].external_folder_id;
          parentFolderId = linkedFiles[providerName].parentMap[folderId];
        }

        return parentFolderId;
      }

      var parentFolderId = getParentFolderId(folderId);

      linkedFiles[providerName].external_folder_id = folderId;
      linkedFiles[providerName].regenerate_url();

      linkedFiles[providerName].fetch({
        reset: true,
        success : function() {

          if(linkedFiles[providerName].external_folder_id != 'all') {

            linkedFiles[providerName].add([{
              external_file_id: parentFolderId,
              id: 'parent-folder',
              icon: "icon-16-arrow-left-grey",
              name: t('Parent Folder #filefinder'),
              mimetype: "folder",
              direction: "back"
            }], { at: 0 });

            linkedFiles[providerName].trigger('reset');
          }
        }
      });
    }

    function onRefreshFiles(providerName) {
      tabViews[providerName].showLoader();
      linkedFiles[providerName].fetch({ reset: true });
    }

    function onRefreshAccounts(providerName) {
      tabViews[providerName].showLoader();
      linkedAccounts.getConnectedByCapability('files');
    }

    function onAddProvider() {

      accountsListView.selectTab( 'providers' );
      helpers.hideOtherTabs( 'providers' );

      if( tabViews['providers'] ) {
        return;
      }

      var accountProviders = new AccountProvidersCollection();
      accountProviders.getAvailableFor('files');

      tabViews['providers'] = new ProvidersMatrixView({
        el : $('.file-finder-content .inner'),
        model: accountProviders,
        capability: 'files',
        eventBridge : eventBridge,
        description: t('Choose an online file provider to share files into Podio. #filefinder')
      });

      tabViews['providers'].render();
      tabViews['providers'].showLoader();

      helpers.toggleOptionsButton( 'providers' );
    }

    function init() {
      eventBridge.bind("dispose", dispose);
      eventBridge.bind("finished", onFinished);
      eventBridge.bind("connectService", onConnectService);
      eventBridge.bind("changeTab", onChangeTab);
      eventBridge.bind("changeUploadTab", showUploadTab);
      eventBridge.bind("changeAccount", onChangeAccount);
      eventBridge.bind("changePermissionSettings", onChangePermissionSettings);
      eventBridge.bind("fileListChanged", onFileListChanged);
      eventBridge.bind("getFolder", onGetFolder);
      eventBridge.bind("refreshFiles", onRefreshFiles);
      eventBridge.bind("refreshAccounts", onRefreshAccounts);
      eventBridge.bind('fileListLimitReached', onFileListLimitReached);
      eventBridge.bind('addProvider', onAddProvider);
      eventBridge.bind('FileFinderPermissionSettings:done', onSettingsFinished);

      // Disable errors messages, since we handle them ourselves
      flashMessage.disableErrorMessages();

      // Switch to upload tab
      showUploadTab();

      // Keyboard shortcuts
      finderView.enableShortcuts();
    }

    function showUploadTab() {
      var account = new ModelPodioBase( {
        provider : 'upload',
        provider_humanized_name : 'Upload',
        capability_names: {'files': 'Upload'}
      });

      eventBridge.trigger("changeTab", account);
    }


    function changeTab(tabName) {
       eventBridge.trigger("changeTab", tabName);
    }

    function dispose() {
      // Clean up state
      linkedFiles = {};
      linkedAccounts = new collectionLinkedAccounts();

      stateModel.clear( { silent : true });
      stateModel.unbind();

      // Dispose tabViews
      _.each(tabViews, function (tab) {
        tab.dispose();
      });
      tabViews = {};

      // Dispose badges
      _.each(badgeViews, function (badge) {
        badge.dispose();
      });
      badgeViews = {};

      // Dispose views
      finderView.disableShortcuts();
      finderView.dispose();
      finderView = null;

      if (accountsListView && _.isFunction(accountsListView.dispose)) {
        accountsListView.dispose();
      }
      accountsListView = null;

      if(permissionWarningView) {
        permissionWarningView.dispose();
      }

      permissionWarningView = null;

      if(permissionSettingsView) {
        permissionSettingsView.dispose();
      }

      permissionSettingsView = null;

      // Enable errors messages
      flashMessage.enableErrorMessages();

      // Hide all setting balloons
      settingsBalloon.hideAll();

      // Signal to the world
      signals.onClose.dispatch();
    }

    return {
      init: init,
      dispose: dispose,
      signals: signals
    };

  };

  return PodioFileFinder;

});

